module.exports = __webpack_public_path__ + "img/1.cf9aa9b8.png";